const generateGeoCoordinates = coordinates => {
  return {
    "@type": "GeoCoordinates",
    latitude: coordinates.lat,
    longitude: coordinates.lon,
  }
}

export default generateGeoCoordinates
